import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ToastError } from "../../Components/utils/ToastMessage";
import { AiOutlineClose } from "react-icons/ai";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import {
    validateEmptySpaces,
    mobileNumberRegex,
    pincodeRegex,
} from "../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState("");
    const watchFormData = watch();
    const [allstates, setStates] = useState([]);

    useEffect(() => {
        if (props.editable) {
            const { ...editData } = props.editable;
            reset({ ...editData, Address: props.editable.shopaddress });
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };

    const onSubmit = (data) => {
        if (!props.editable) {
            Services.addShop("POST", JSON.stringify(data), token)
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/shop?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories();
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else {
            let updated_Values = { ...data, id: props.editable._id };
            let updated = new FormData();
            Object.keys(updated_Values).forEach((key) => {
                updated.set(key, updated_Values[key]);
            });
            fetch(`${process.env.REACT_APP_BASE_URL_PYTHON}/${Services.editShop}`, {
                method: "POST",
                body: updated,
                Authorization: `token ${sessionStorage.getItem("token")}`,
            })
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    if (res.Status === 1) {
                        Navigate(`/shop?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories();
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };
    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>{props.editable ? "Update Shop" : "Add Shop"}</h3>
                        <p>
                            {props.editable ? "Update Shop" : "Add Shop"} and
                            necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("name", {
                                    required: "Name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.name && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.name?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Mobile</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("mobile", {
                                    required: "Mobile is required",
                                    pattern: {
                                        value: mobileNumberRegex,
                                        message:
                                            "Please enter a valid mobile number",
                                    },
                                })}
                            />
                            {errors?.mobile && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.mobile?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Password</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="password"
                                {...register("password", {
                                    required: "password is required",
                                })}
                            />
                            {errors?.password && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.password?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Long-lat</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                placeholder="17.467,17.232"
                                {...register("longlat", {
                                    required: "Long lat is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.longlat && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.longlat?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Shop address</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("Address", {
                                    required: "shop address is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.Address && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.Address?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">
                            Pincodes (with ,Seperation)
                        </label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("pincodes", {
                                    required: "pincodes are required",
                                    pattern: {
                                        value: pincodeRegex,
                                        message: "Please enter valid pincode",
                                    },
                                })}
                            />
                            {errors?.pincodes && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.pincodes?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div> */}

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Shop"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
